import { AdminJumpShipHistory, PlayerJumpShipReasonType } from '@golden/gdk-admin'
import { Box } from '@material-ui/core'
import React, { memo, useMemo } from 'react'
import playerJumpShipReasonName from '../../../constants/admin/playerJumpShipReasonName'
import useT from '../../../i18ns/admin/useT'
import { createTableData } from '../../../utils/default/TableHelper'
import CoreTable from '../../default/present/CoreTable'
import { format } from 'date-fns'
import { useCommonStyles } from '../../../utils/admin/StyleHook'

interface RowType {
  id: number
  new_staff_account: string
  reason: string
  processed_at: string | null
  operator_account: string
}

const JumpShipHistoryTable = memo<{ jumpShipHistory: AdminJumpShipHistory[] }>(({ jumpShipHistory }) => {
  const { t } = useT()
  const classes = useCommonStyles()

  const tableClasses = useMemo(() => ({
    head: classes.greyTableHead,
    row: classes.tableRow,
    cellHead: classes.tableCellHead,
    cellBody: classes.nowrap
  }), [classes])

  const data = useMemo(() => {
    const rows = jumpShipHistory.map((history, index) => ({
      id: index,
      new_staff_account: history.new_staff_account,
      reason: history.reason === PlayerJumpShipReasonType.CUSTOM ?
        `${t(playerJumpShipReasonName[history.reason])}：${history.description}` :
        t(playerJumpShipReasonName[history.reason]),
      processed_at: history.processed_at ? format(history.processed_at, 'yyyy-MM-dd HH:mm:ss') : t('common.pendingJumpShip'),
      operator_account: history.operator_account
    }))

    return createTableData<RowType>(
      {
        id: {
          label: '',
          value: 'id'
        },
        new_staff_account: {
          label: t('common.newStaff'),
          value: 'new_staff_account'
        },
        reason: {
          label: t('common.reason'),
          value: 'reason'
        },
        processed_at: {
          label: t('common.systemOperationTime'),
          value: 'processed_at'
        },
        operator_account: {
          label: t('common.updateBy'),
          value: 'operator_account'
        }
      },
      ['new_staff_account', 'reason', 'processed_at', 'operator_account'],
      rows,
      'id'
    )
  }, [jumpShipHistory, t])

  return (
    <Box style={{
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      transform: 'translateY(100%)',
      minWidth: '600px',
      maxWidth: '800px',
      maxHeight: '250px',
      background: '#fff',
      zIndex: 1,
      border: '1px solid #000',
      overflow: 'auto',
    }}>
      <CoreTable
        data={data}
        total={jumpShipHistory.length}
        classes={tableClasses}
      />
    </Box>
  )
})

export default JumpShipHistoryTable
